import React, {useEffect, useState} from 'react';
import { useDispatch } from 'react-redux';

import {addGameClaimVariables} from "_features/entries/entry-slice";
import {ResultActionButtons} from "_components/ActionButtons/ResultActionButtons";
import {ResultCopy} from "_components/ResultCopy/ResultCopy";
import { WinningAnimationWrapper } from '_pages/Variations/Animation/WinningAnimation/WinningAnimationWrapper';

import {
    empty,
    logIt
} from "__globals/global-functions";

import * as GC from '__globals/GLOBAL-CONSTANTS.js';

// import {
//     getJsonContent,
//     setContent,
//     getJsonResultCopy
// } from "__globals/copy-functions";
//
// import {
//     goNextPage
// } from '__globals/page-flow';





// import {PAGE_IW_MATCH_CONFIGURABLE} from "__globals/GLOBAL-CONSTANTS.js";
// import {addCSSClass} from "../../../../__globals/css-functions";



export const WinSendDigitalPrize = props => {

    logIt( GC.RESULT_DIGITAL + " RESULT IS CALLED", null, false );

    const RESULT_KEY = GC.RESULT_DIGITAL; // for the title and copy

    const dispatch = useDispatch();

    /** Retrieve the game claim variables */
    useEffect(() => {
        if ( !empty(props.gameClaim) && !empty(props.promotion) ) {
            dispatch( addGameClaimVariables(props.gameClaim) );
        }
    }, [props.gameClaim, props.promotion]);

    // LOCAL VARIABLES
    // const [showTitle, setShowTitle] = useState( false);
    // const [showResultCopy, setShowResultCopy] = useState( true);
    // const [showCopy, setShowCopy] = useState( false);
    // const [showActionOne, setShowActionOne] = useState( true);
    // const [showActionTwo, setShowActionTwo] = useState( false);
    // const [showActionThree, setShowActionThree] = useState( false);

    // const handleActionButton1 = () => {
    //     let action = props.gameClaim?.parameters?.resultScreen?.actionOne?.action;
    //     let value = props.gameClaim?.parameters?.resultScreen?.actionOne?.value;
    //     props.handleAction( action, value );
    // }
    //
    // const handleActionButton2 = () => {
    //     let action = props.gameClaim?.parameters?.resultScreen?.actionTwo?.action;
    //     let value = props.gameClaim?.parameters?.resultScreen?.actionTwo?.value;
    //     props.handleAction( action, value );
    // }
    //
    // const handleActionButton3 = () => {
    //     let action = props.gameClaim?.parameters?.resultScreen?.actionThree?.action;
    //     let value = props.gameClaim?.parameters?.resultScreen?.actionThree?.value;
    //     props.handleAction( action, value );
    // }

    //const action1Ref = useRef( <div id="ai_win_screen_button_1" onClick={handleActionButton1}>Action One</div> );

    /** Sets the result css from the game claim */
    // useEffect(() => {
    //     if ( !empty(props.gameClaim) && !empty(props.promotion) ) {
    //         setShowTitle( props.gameClaim?.parameters?.resultScreen?.showTitle );
    //         setShowResultCopy( props.gameClaim?.parameters?.resultScreen?.showResultCopy );
    //         setShowCopy( props.gameClaim?.parameters?.resultScreen?.showCopy );
    //         setShowActionOne( props.gameClaim?.parameters?.resultScreen?.actionOne?.show );
    //         setShowActionTwo( props.gameClaim?.parameters?.resultScreen?.actionTwo?.show );
    //         setShowActionThree( props.gameClaim?.parameters?.resultScreen?.actionThree?.show );
    //     }
    // }, [props.gameClaim, props.promotion]);

    {/** Put in copy based on show flags */}
//     useEffect(() => {
//         if ( showTitle && !empty(props.promotion) ) {
//             let digitalWinScreenTitle = getJsonContent(props.promotion, GC.RESULT_DIGITAL, "title", "<h2>DEFAULT TITLE</h2>", props.entry );
//             setContent("send_digital_win_screen_title", digitalWinScreenTitle);
//         }
//     }, [showTitle]);
//     useEffect(() => {
//         if ( showResultCopy && !empty(props.promotion) && !empty(props.gameClaim) ) {
//             let resultCopy = getJsonResultCopy(props.promotion, GC.RESULT_DIGITAL, props.gameClaim, "<h2>ERROR</h2>", props.entry );
//             setContent("send_digital_win_screen_result_copy", resultCopy);
//         }
//     }, [showResultCopy]);
//     useEffect(() => {
//         if ( showCopy && !empty(props.promotion) ) {
//             let digitalWinScreenCopy = getJsonContent(props.promotion, GC.RESULT_DIGITAL, "copy", "<h2>DEFAULT COPY</h2>", props.entry );
//             setContent("send_digital_win_screen_copy", digitalWinScreenCopy);
//         }
//     }, [showCopy]);
//     useEffect(() => {
//         if ( showActionOne && !empty(props.promotion) ) {
//             let digitalWinScreenButton1 = getJsonContent(props.promotion, GC.RESULT_DIGITAL, "button1", "<h2>DEFAULT BTN 1</h2>", props.entry );
//             setContent("send_digital_win_screen_button_1", digitalWinScreenButton1);
// //action1Ref.current.click.handler = handleActionButton1;
//         }
//     }, [showActionOne]);
//     useEffect(() => {
//         if ( showActionTwo && !empty(props.promotion) ) {
//             let digitalWinScreenButton2 = getJsonContent(props.promotion, GC.RESULT_DIGITAL, "button2", "<h2>DEFAULT BTN 2</h2>", props.entry );
//             setContent("send_digital_win_screen_button_2", digitalWinScreenButton2);
//         }
//     }, [showActionTwo]);
//     useEffect(() => {
//         if ( showActionThree && !empty(props.promotion) ) {
//             let digitalWinScreenButton3 = getJsonContent(props.promotion, GC.RESULT_DIGITAL, "button3", "<h2>DEFAULT BTN 3</h2>", props.entry );
//             setContent("send_digital_win_screen_button_3", digitalWinScreenButton3);
//         }
//     }, [showActionThree]);
    {/** END of put in copy based on show flags */}

    // RETURN THE GAME RESULT
    return (
        <div id='win_send_digital_prize' >
            {/*{showTitle && <div id="send_digital_win_screen_title">Title One</div>}*/}
            {/*{showCopy && <div id="send_digital_win_screen_copy">Copy One</div>}*/}
            {/*{showResultCopy && <div id="send_digital_win_screen_result_copy">Result Copy</div>}*/}
            {/*{showActionOne && <div id="send_digital_win_screen_button_1" onClick={handleActionButton1}>Claim Your Prize</div>}*/}
            {/*{showActionTwo && <div id="send_digital_win_screen_button_2" onClick={handleActionButton2}>Claim Your Prize</div>}*/}
            {/*{showActionThree && <div id="send_digital_win_screen_button_3" onClick={handleActionButton3}>Claim Your Prize</div>}*/}

            <ResultCopy
                jsonKey={RESULT_KEY}
                entry={props.entry}
                promotion={props.promotion}
                gameClaim={props.gameClaim}
            />

            <ResultActionButtons
                promotion={props.promotion}
                gameClaim={props.gameClaim}
                jsonKey={RESULT_KEY}
                doAction={props.doAction}
            />

            <WinningAnimationWrapper
                promotion={props.promotion}
                animationGo={props.animationGo}
            />

         </div>
    );
}

export default WinSendDigitalPrize;